import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { CustomModalService } from '@piqet-angular/shared';

@Component({
  selector: 'piqet-angular-import-version-comment',
  templateUrl: './import-version-comment.component.html',
  styleUrls: ['./import-version-comment.component.scss'],
})
export class ImportVersionCommentComponent implements OnInit {
  // Emits the import payload back to the host grid once the user confirms.
  // Both fields are optional, so they are emitted as null when left blank.
  @Output() importConfirm = new EventEmitter<{
    id: any;
    version: string | null;
    comment: string | null;
  }>();

  importForm!: FormGroup;
  id: any;
  fileName: any;
  submitting = false;

  readonly maxVersionLength = 100;
  readonly maxCommentLength = 500;

  constructor(private fb: FormBuilder, private modal: CustomModalService) {}

  ngOnInit(): void {
    const initialState: any = this.modal?.modalService?.config?.initialState;
    this.id = initialState?.['id'];
    this.fileName = initialState?.['fileName'];

    this.importForm = this.fb.group({
      version: ['', [Validators.maxLength(this.maxVersionLength)]],
      comment: ['', [Validators.maxLength(this.maxCommentLength)]],
    });
  }

  get f() {
    return this.importForm.controls;
  }

  onImport() {
    if (this.importForm.invalid) {
      this.importForm.markAllAsTouched();
      return;
    }
    this.submitting = true;
    const { version, comment } = this.importForm.value;
    this.importConfirm.emit({
      id: this.id,
      version: version?.trim() ? version.trim() : null,
      comment: comment?.trim() ? comment.trim() : null,
    });
  }

  onClose() {
    this.modal.close();
  }
}
